import React, { useCallback } from "react";
import {Grid} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import {AddButton} from "../AddButton/AddButton";
import {FakeFieldTemplate} from "../FakeFieldTemplate/FakeFieldTemplate";

const sortBySequenceNumber = (a, b) => a.sequenceNumber - b.sequenceNumber

const changePositionFieldTemplate = (arr, targetFieldId, currentSequenceNumber, newSequenceNumber) => {
    return arr.map(field => {
        if (field.id === targetFieldId) {
            return {...field, sequenceNumber: Number(newSequenceNumber)}
        }
        if (field.sequenceNumber >= newSequenceNumber && field.sequenceNumber < currentSequenceNumber
            && newSequenceNumber - currentSequenceNumber < 0) {
            return {...field, sequenceNumber: field.sequenceNumber + 1}
        }
        if (field.sequenceNumber <= newSequenceNumber && field.sequenceNumber > currentSequenceNumber
            && newSequenceNumber - currentSequenceNumber > 0
        ) {
            return {...field, sequenceNumber: field.sequenceNumber - 1}
        }
        if (field.sequenceNumber === newSequenceNumber && field.sequenceNumber > currentSequenceNumber
            && newSequenceNumber - currentSequenceNumber > 0
        ) {
            return {...field, sequenceNumber: field.sequenceNumber + 1}
        }
        return field
    }).sort(sortBySequenceNumber)
}

const fieldTemplatesSort = (newSequenceNumber, currentSequenceNumber, targetFieldId, arr) => {
    if (newSequenceNumber === currentSequenceNumber || !newSequenceNumber) return arr
    if (Number(newSequenceNumber) >= arr.length) {
        return changePositionFieldTemplate(arr, targetFieldId, currentSequenceNumber, arr.length)
    }
    if (Number(newSequenceNumber) < 1) {
        return changePositionFieldTemplate(arr, targetFieldId, currentSequenceNumber, 1)
    }
    return changePositionFieldTemplate(arr, targetFieldId, currentSequenceNumber, newSequenceNumber)
}

export const FakeFieldGrid = ({
                                  fakeFields,
                                  handleAddButtonClick,
                                  handleSequenceNumberChange,
                                  handleFieldTemplateDelete,
                                  handleFieldTemplateClick,
                                  setFieldValue,
                                  activeStep,
                              }) => {
    const handleSequenceNumberChangeWrap = (currentSequenceNumber, targetFieldId) => (event) => {
        const newSequenceNumber = event.target.value
        event.target.select()
        handleSequenceNumberChange(fieldTemplatesSort(newSequenceNumber, currentSequenceNumber, targetFieldId, fakeFields))
    }

    const handleFieldTemplateDeleteWrap = (index, fieldProps) => () => {
        handleFieldTemplateDelete(fieldProps, fakeFields.filter((_, i) => i !== index)
            .map((el, i) => ({...el, sequenceNumber: i + 1})))
    }

    const handleFieldTemplateClickWrap = index => () => {
        handleFieldTemplateClick(index)
    }

    const goodFields = (fields) => {
        for(let field of fields) {
            if (field === undefined) {
                return false
            }
        }    
        return true
    }

    const moveField = useCallback((dragIndex, hoverIndex) => {


        const newFakeFieldsSequence = fakeFields.map((field, index) => {
            if (index === dragIndex) {
                field.sequenceNumber = hoverIndex + 1
                return field
            } else if (index === hoverIndex) {
                field.sequenceNumber = dragIndex + 1
                return field
            } else return field
        })

        const dragCard = newFakeFieldsSequence[dragIndex];
        const newFields = [...newFakeFieldsSequence]
        newFields.splice(dragIndex, 1)
        newFields.splice(hoverIndex, 0, dragCard)

        if (goodFields(newFields)) {
            if (newFields[0].step) {
                setFieldValue(`fieldTemplates[${activeStep}]`, newFields)
            } else {
                setFieldValue(`content.offenseWindow`, newFields)
            }  
        }

    }, [fakeFields, activeStep, setFieldValue]);


    return <Grid container item>
        <Grid item container alignItems={"center"}>
            <Grid item>
                <Typography variant={'subtitle2'}>
                    Элементы
                </Typography>
            </Grid>
            <Grid item>
                <AddButton onClick={handleAddButtonClick}/>
            </Grid>
        </Grid>
        <Grid item container spacing={1} justifyContent={'flex-start'}>
            {fakeFields.map((fieldProps, index) =>
                <FakeFieldTemplate {...fieldProps}
                                   key={`field-template${fieldProps.variable}`}
                                   handleSequenceNumberChange={handleSequenceNumberChangeWrap(
                                       fieldProps.sequenceNumber,
                                       fieldProps.id
                                   )}
                                   handleFieldTemplateDelete={handleFieldTemplateDeleteWrap(index, fieldProps)}
                                   handleFieldTemplateClick={handleFieldTemplateClickWrap(index)}
                                   moveField={moveField}
                                   index={index}
                />
            )}
        </Grid>
    </Grid>
}